import { FC } from "react"
import Image from "next/image"
import styled from "styled-components"
import { ContentBlock, ContentfulProductWithShopifyData } from "@lib/types"

import { ProductListing } from "./ProductListing"
import { TextBlock } from "@components/common"

interface Props {
  data: {
    alignStatic: string
    contentBlock: ContentBlock
    productsCollection: {
      items: ContentfulProductWithShopifyData[]
    }
  }
}

export const ProductsShortStatic: FC<Props> = ({ data }) => {
  const { alignStatic, contentBlock, productsCollection } = data

  return (
    <StyledProductsShortStatic $alignStatic={alignStatic}>
      <ProductListing products={productsCollection.items} repeat={2} />
      <ImageContainer>
        <Image
          src={contentBlock.image.url}
          alt={contentBlock.image.description}
          width={535}
          height={381}
          layout="responsive"
        />
        <TextBlockWrapper>
          <TextBlock textBlock={contentBlock.textBlock} />
        </TextBlockWrapper>
      </ImageContainer>
    </StyledProductsShortStatic>
  )
}

interface StyleProps {
  $alignStatic: string
}

const StyledProductsShortStatic = styled.div<StyleProps>`
  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    display: grid;
    direction: ${({ $alignStatic }) =>
      $alignStatic === "Left" ? "rtl" : "ltr"};
    grid-template-columns: 1fr 1fr;
    grid-gap: 2.9rem;
    margin: 0 0 3rem;
  }
`

const ImageContainer = styled.div`
  position: relative;
  margin: 0 0 3.3rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    margin: 0 0 2.5rem;
  }
`

const TextBlockWrapper = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 25rem;

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0 0 0.8rem;
    font-size: 2.4rem;
    line-height: 3.1rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    font-size: 1.5rem;
    line-height: 2.2rem;
  }
`
